import { Button as AntButton, ButtonProps, Flex, Form } from 'antd';
import React from 'react';

interface Props extends ButtonProps {
  name: string;
  justify?: React.CSSProperties['justifyContent'];
}

const SubmitButton: React.FC<Props> = ({ name, justify = 'end', ...rest }) => {
  return (
    <Form.Item style={{ padding: 0, margin: 0 }}>
      <Flex justify={justify}>
        <AntButton {...rest} type='primary' htmlType='submit'>
          {name}
        </AntButton>
      </Flex>
    </Form.Item>
  );
};

export default SubmitButton;
